import { TColors } from '../../common/types/styles/colors';

// Use this if using semi-transparent colors/backgrounds
// const getRGBA = (hex: string, alpha = 1): string =>
//     `rgba(${parseInt(hex.substring(1, 3), 16)},${parseInt(hex.substring(3, 5), 16)},${parseInt(
//         hex.substring(5, 7),
//         16,
//     )},${alpha})`;

export type TKulColors = TColors & {
    brandTertiary: string;
    brandSecondaryDark: string;
    brandPrimaryLight: string;
    brandSecondaryLight: string;
    brandTertiaryLight: string;
    bgOverlay: string;
    bodyAlt: string;
    bgFooter: string;
    bgMild: string;
    generalRight: string;
    bgQuaternary: string;
    bgQuinary: string;
    borderPorcelain: string;
    bgCartInvoice: string;
    generalGreyLight: string;
    ctaDisabledColor: string;
    ctaDisabledTextColor: string;
};

export const metrics = {
    headerHeight: 60,
    bottomTabsHeight: 56,
};

// --- Colors
export const colors: TKulColors = {
    // Brand
    brandPrimary: '#f74850', // Red
    brandPrimaryLight: '#feeced', // Light Red
    brandSecondary: '#008fbe', // Blue
    brandSecondaryLight: '#F0F6F8', // Light Blue
    brandSecondaryDark: '#2496B7', // Dark Blue
    brandTertiary: '#FFD700', // Yellow
    brandTertiaryLight: '#FFF6D6', // Yellow

    // Background
    bgPrimary: '#fff', // White
    bgSecondary: '#404553', // Dark Grey
    bgSupport: '#fff8ec', // Pale Yellow
    bgTertiary: '#ECF0F0', // Light-Grey
    bgQuaternary: `#ecf0f0`,
    bgQuinary: '#f3f9fb',
    bgSupportAlt: '#F0F6F8', // Light Grey-Blue
    bgSupportLight: '#F1F4FD', // Light Transparent Blue
    bgOverlay: 'rgba(0, 0, 0, 0.5)',
    bgFooter: '#575756', // footer bg color
    bgMild: '#f0f6f8',
    bgCartInvoice: '#f4fbfe', // cart invoice bg color

    // Body
    body: '#333333', // Black
    bodyMid: '#7E859B', // Mid-Grey
    bodyLight: '#b2bbd2', // Light-Grey
    bodyLightest: '#f7f7fa', // Lightest-Grey
    bodyAlt: '#fff', // White
    bodyDark: '#6a7081', // Pale-Sky

    // Border
    border: '#2496B7',
    borderLight: '#ebecf0',
    borderDark: '#e2e5f1',
    borderBlue: '',
    borderLightShadow: '',
    borderPorcelain: `#ecf0f0`,

    // General
    generalWarning: '#f74850', // Red
    generalWarningLight: '#fb0000', // Light-Red
    generalPositive: '#18CC76', // Green
    generalPositiveLight: '#e4f7db', // Light-Green
    generalHazard: '#f5a523', // Orange
    generalRating: '#f5a523', // Orange
    generalSale: '#f6583d', // Coral
    generalFreebie: '#00B06A', // Green
    gereralIconBG: '#fcfbf4', // Light Yellow
    generalDeal: '#9B51E0', // Purple
    generalRight: '#b2bbd2', // greenis gray
    generalLabel: '#bababa',
    generalBadge: '#59b7a4',
    generalBlack: '#333333',
    generalGreyLight: '#f2f2f2',
    generalAttachment: '',
    statusOrdered: '',
    statusProcessing: '',
    statusShipped: '',

    // OTHER
    ctaDisabledBg: '#f0f0f2',
    ctaDisabledBody: '#b2bbd2',

    renewedGrade1: '#39aacc',
    renewedGrade2: '#33b9a2',
    renewedGrade3: '#5953a3',
    renewedGrade4: '#e04f8a',
    renewedGrade5: '#a45da5',

    //   generalHazardColor() { return '#f3ac30'; }
};

export const marketplaceStyles = (): string => {
    return `
        /* latin */
        @font-face {
            font-family: 'Archivo';
            font-style: normal;
            font-weight: 400;
            font-display: swap;
            src: local('Archivo Regular'), local('Archivo-Regular'), url(https://fonts.gstatic.com/s/archivo/v6/k3kQo8UDI-1M0wlSfdnoLmvDIaI.woff2) format('woff2');
            unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
        }

        /* latin */
        @font-face {
            font-family: 'Archivo';
            font-style: normal;
            font-weight: 600;
            font-display: swap;
            src: local('Archivo SemiBold'), local('Archivo-SemiBold'), url(https://fonts.gstatic.com/s/archivo/v6/k3kVo8UDI-1M0wlSdQbMO0bhLIiP-Q8.woff2) format('woff2');
            unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
        }

        /* latin */
        @font-face {
            font-family: 'Archivo';
            font-style: normal;
            font-weight: 700;
            font-display: swap;
            src: local('Archivo Bold'), local('Archivo-Bold'), url(https://fonts.gstatic.com/s/archivo/v6/k3kVo8UDI-1M0wlSdWLNO0bhLIiP-Q8.woff2) format('woff2');
            unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
        }

        /* arabic */
        @font-face {
            font-family: 'Almarai';
            font-style: normal;
            font-weight: 400;
            font-display: swap;
            src: local('Almarai'), local('Almarai-Regular'), url(https://fonts.gstatic.com/s/almarai/v2/tsstApxBaigK_hnnQ1iFo1K0rqbPqA.woff2) format('woff2');
            unicode-range: U+0600-06FF, U+200C-200E, U+2010-2011, U+204F, U+2E41, U+FB50-FDFF, U+FE80-FEFC;
        }

        /* arabic */
        @font-face {
            font-family: 'Almarai';
            font-style: normal;
            font-weight: 600;
            font-display: swap;
            src: local('Almarai Bold'), local('Almarai-Bold'), url(https://fonts.gstatic.com/s/almarai/v2/tssoApxBaigK_hnnS-agtnqWo4z1oXli2g.woff2) format('woff2');
            unicode-range: U+0600-06FF, U+200C-200E, U+2010-2011, U+204F, U+2E41, U+FB50-FDFF, U+FE80-FEFC;
        }

        /* arabic */
        @font-face {
            font-family: 'Almarai';
            font-style: normal;
            font-weight: 700;
            font-display: swap;
            src: local('Almarai ExtraBold'), local('Almarai-ExtraBold'), url(https://fonts.gstatic.com/s/almarai/v2/tssoApxBaigK_hnnS_qjtnqWo4z1oXli2g.woff2) format('woff2');
            unicode-range: U+0600-06FF, U+200C-200E, U+2010-2011, U+204F, U+2E41, U+FB50-FDFF, U+FE80-FEFC;
        }
        .siteWidthContainer {
            padding: 0 16px;
            margin: 0 auto;
            max-width: 1440px;
            box-sizing: border-box;
        }

        html {
            font-size: 13px;
        }

        body {
            background-color: #ECF0F0;
            font-family: 'Archivo', 'Helvetica Neue', arial, sans-serif;
            color: #333333;
        }

        html[dir=rtl] body {
            font-family: 'Almarai', Tahoma, sans-serif;
        }

        input, textarea, select  {
            border: 1px solid #e2e5f1;
        }
    `;
};

const theme = {
    colors,
    metrics,
};

export default theme;
